import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-253" data-mp="3utm4aq96wfw5">
      <div className="mx-auto max-w-5xl" data-id="element-254" data-mp="cor8kng50r26">
        <div className="mx-auto max-w-2xl text-center" data-id="element-255" data-mp="cnpv6cbnfsha">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-256" data-mp="7p68g9p8ecnv">
            5 tomów do wydrukowania
          </h2>
          <p className="mt-3 text-sm text-foreground/70 sm:text-base" data-id="element-257" data-mp="3g354tcg4801w">
            120 jednostronicowych kart projektów, pogrupowanych według tego, co dzieci najbardziej
            lubią budować.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-258" data-mp="3l4kp32agy2j8">
          {volumes.map((volume, i) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex gap-4 rounded-2xl border border-primary/15 bg-card p-5 shadow-sm shadow-foreground/5 sm:gap-6 sm:p-7" data-id="element-259" data-mp="2xe87t0tc2tfz" data-mpi={i}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-260" data-mp="2j6d303ps1ftd">
                <span className="font-display text-3xl font-bold leading-none text-primary sm:text-4xl" data-id="element-261" data-mp="2o453hm4hma96">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-foreground sm:text-lg" data-id="element-262" data-mp="1qih3kr8tp9sw">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground/70" data-id="element-263" data-mp="20eanwwssa7l8">
                  {volume.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-secondary px-3 py-1 text-xs font-semibold text-primary-strong" data-id="element-264" data-mp="24hqno205go25">
                  {volume.tag}
                </span>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-secondary p-1.5" data-id="element-265" data-mp="3fxnlygtvokc1">
                <img src={volume.coverImage} alt={`Printable build cards from Volume ${volume.number}: ${volume.title}`} loading="lazy" className="block h-[110px] w-[110px] rounded-lg object-cover sm:h-[150px] sm:w-[150px]" data-id="element-266" data-mp="1gozp5cur99pc" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}